import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { routes } from './app.routes';
import { ErrorStateMatcher } from '@angular/material/core';
import { TouchedErrorStateMatcher } from './core/classes/error-state-matcher';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
     provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);
      iconRegistry.setDefaultFontSetClass('material-icons');
      iconRegistry.addSvgIcon('logo-small', sanitizer.bypassSecurityTrustResourceUrl('logo/logo-small.svg'));
    }),
    { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher },
  ]
};
